const repo = 'https://github.com/kspeer825/portfolio/tree/main/projects';

export interface ProjectLink {
  label: string;
  href: string;
  note?: string;
  extra?: { label: string; href: string }[];
}

export interface PersonalProject {
  title: string;
  subtitle: string;
  tools: string[];
  context: string;
  href: string;
  links: ProjectLink[];
}

export const personalProjects: PersonalProject[] = [
  {
    title: 'Serverless CI/CD Platform',
    subtitle: 'Jenkins ECS Cluster',
    tools: ['Terraform', 'AWS VPC', 'ALB', 'ECS', 'CloudWatch', 'IAM', 'EFS', 'Jenkins'],
    context:
      'Jenkins is an open source orchestration tool for automation pipelines. It is traditionally run on servers with static IPs, however it can be run in a serverless environment. This implementation leverages ECS Fargate tasks and VPC endpoints making it cost-effective, scalable, and secure.',
    href: `${repo}/jenkins/`,
    links: [
      { label: 'Application Load Balancer', href: `${repo}/jenkins/terraform/alb.tf`, note: 'accessible via white-listed IPs' },
      { label: 'ECS Cluster', href: `${repo}/jenkins/terraform/ecs.tf`, note: 'running Fargate tasks in a private subnet' },
      { label: 'VPC', href: `${repo}/jenkins/terraform/vpc.tf`, note: 'using AWS PrivateLink for service-to-service communication' },
      {
        label: 'ECR',
        href: `${repo}/jenkins/terraform/ecr.tf`,
        note: 'private repo for storing the Jenkins Docker image',
        extra: [{ label: 'Image', href: `${repo}/jenkins/jenkins/` }],
      },
    ],
  },
  {
    title: 'This Website',
    subtitle: 'Static website via S3 and CloudFront',
    tools: ['Terraform', 'GitHub Actions', 'AWS S3', 'CloudFront', 'Route53', 'TypeScript', 'React'],
    context:
      'My personal website started out as a take-home project for an interview, and I ended up keeping it around to use as an extension of my resume with details of personal projects and professional experiences.',
    href: `${repo}/website/`,
    links: [
      { label: 'Backend infrastructure', href: `${repo}/website/infra#s3-static-website-infrastructure`, note: 'lightweight, immutable, and managed entirely with Terraform' },
      { label: 'Frontend', href: `${repo}/website/speerportfolio`, note: 'written in TypeScript using React components' },
      { label: 'Deployments', href: 'https://github.com/kspeer825/portfolio/actions', note: 'run via GitHub Actions workflows' },
    ],
  },
  {
    title: 'Containerization',
    subtitle: 'Single purpose Docker images',
    tools: ['Docker', 'Go'],
    context: 'A series of simple, single-purpose base images available on Docker Hub meant for local iteration.',
    href: `${repo}/docker/`,
    links: [
      {
        label: 'Terraform',
        href: `${repo}/docker/docker-terraform#base-terraform-image`,
        extra: [{ label: 'Docker Hub', href: 'https://hub.docker.com/r/kspeer825/terraform/' }],
      },
      {
        label: 'Clojure',
        href: `${repo}/docker/docker-clojure#base-clojure-image`,
        extra: [{ label: 'Docker Hub', href: 'https://hub.docker.com/r/kspeer825/clojure/' }],
      },
      {
        label: 'Python',
        href: `${repo}/docker/docker-python#base-python-image`,
        extra: [{ label: 'Docker Hub', href: 'https://hub.docker.com/r/kspeer825/python' }],
      },
      {
        label: 'Go',
        href: `${repo}/docker/docker-go#base-go-image`,
        extra: [{ label: 'Docker Hub', href: 'https://hub.docker.com/r/kspeer825/go' }],
      },
    ],
  },
];
